<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>{{ $t('housekeepingType.queryCondition') }}</h5>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="ibox-content">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="housekeepingTypeInfo.conditions.hktName"
                :placeholder="$t('housekeepingType.typeNamePlaceholder')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-select
                v-model="housekeepingTypeInfo.conditions.isShow"
                :placeholder="$t('housekeepingType.showStatusPlaceholder')"
                style="width:100%"
                clearable
              >
                <el-option
                  v-for="item in housekeepingTypeInfo.isShows"
                  :key="item.statusCd"
                  :label="item.name"
                  :value="item.statusCd"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-select
                v-model="housekeepingTypeInfo.conditions.ispublic"
                :placeholder="$t('housekeepingType.publicStatusPlaceholder')"
                style="width:100%"
                clearable
              >
                <el-option
                  label="公共类"
                  value="Y"
                />
                <el-option
                  label="自定义"
                  value="N"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button
              type="primary"
              size="small"
              @click="_queryHousekeepingTypeMethod"
            >
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="_resetHousekeepingTypeMethod"
            >
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-title">
        <h5>{{ $t('housekeepingType.housekeepingType') }}</h5>
        <div class="ibox-tools" style="top:10px;">
          <el-button
            type="primary"
            size="small"
            @click="_openAddHousekeepingTypeModal"
          >
            <i class="el-icon-plus"></i> {{ $t('common.add') }}
          </el-button>
        </div>
      </div>
      <div class="ibox-content">
        <el-table
          :data="housekeepingTypeInfo.housekeepingTypes"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="hktIcon"
            :label="$t('housekeepingType.logo')"
            align="center"
          >
            <template #default="{row}">
              <img
                style="width: 60px; height: 60px; border-radius: 5px;"
                :src="row.hktIcon"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="hktName"
            :label="$t('housekeepingType.typeName')"
            align="center"
          />
          <el-table-column
            prop="hktDesc"
            :label="$t('housekeepingType.serviceDesc')"
            align="center"
          />
          <el-table-column
            prop="label"
            :label="$t('housekeepingType.label')"
            align="center"
          />
          <el-table-column
            prop="seq"
            :label="$t('housekeepingType.sort')"
            align="center"
          />
          <el-table-column
            prop="isShow"
            :label="$t('housekeepingType.showStatus')"
            align="center"
          >
            <template #default="{row}">
              {{ row.isShow === 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('common.operation')"
            align="center"
          >
            <template #default="{row}">
              <el-button
                v-if="row.shopId !== '9999'"
                type="text"
                size="small"
                @click="_openEditHousekeepingTypeModel(row)"
              >
                {{ $t('common.edit') }}
              </el-button>
              <el-button
                v-if="row.shopId !== '9999'"
                type="text"
                size="small"
                @click="_openDeleteHousekeepingTypeModel(row)"
              >
                {{ $t('common.delete') }}
              </el-button>
              <span v-else>{{ $t('housekeepingType.publicType') }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          :current-page="housekeepingTypeInfo.conditions.page"
          :page-size="housekeepingTypeInfo.conditions.row"
          :total="housekeepingTypeInfo.total"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <add-housekeeping-type ref="addHousekeepingType" />
    <edit-housekeeping-type ref="editHousekeepingType" />
    <delete-housekeeping-type ref="deleteHousekeepingType" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { queryHousekeepingType } from '@/api/housekeeping/housekeepingTypeApi'
import AddHousekeepingType from '@/components/housekeeping/addHousekeepingType.vue'
import EditHousekeepingType from '@/components/housekeeping/editHousekeepingType.vue'
import DeleteHousekeepingType from '@/components/housekeeping/deleteHousekeepingType.vue'

export default {
  name: 'HousekeepingType',
  components: {
    AddHousekeepingType,
    EditHousekeepingType,
    DeleteHousekeepingType
  },
  data() {
    return {
      housekeepingTypeInfo: {
        housekeepingTypes: [],
        total: 0,
        records: 1,
        moreCondition: false,
        hktId: '',
        isShows: [],
        conditions: {
          ispublic: '',
          hktName: '',
          isShow: '',
          shopId: '',
          typeCd: '1001',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listHousekeepingTypes(1, 10)
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const {data} = await getDict('housekeeping_type', 'is_show')
        this.housekeepingTypeInfo.isShows = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listHousekeepingTypes(page, rows) {
      this.housekeepingTypeInfo.conditions.page = page
      this.housekeepingTypeInfo.conditions.row = rows
      try {
        const res = await queryHousekeepingType(this.housekeepingTypeInfo.conditions)
        this.housekeepingTypeInfo.total = res.total
        this.housekeepingTypeInfo.records = res.records
        this.housekeepingTypeInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddHousekeepingTypeModal() {
      this.$refs.addHousekeepingType.open()
    },
    _openEditHousekeepingTypeModel(row) {
      this.$refs.editHousekeepingType.open(row)
    },
    _openDeleteHousekeepingTypeModel(row) {
      this.$refs.deleteHousekeepingType.open(row)
    },
    _queryHousekeepingTypeMethod() {
      this._listHousekeepingTypes(1, 10)
    },
    _resetHousekeepingTypeMethod() {
      this.housekeepingTypeInfo.conditions = {
        ispublic: '',
        hktName: '',
        isShow: '',
        shopId: '',
        typeCd: '1001',
        page: 1,
        row: 10
      }
      this._listHousekeepingTypes(1, 10)
    },
    handleCurrentChange(val) {
      this._listHousekeepingTypes(val, this.housekeepingTypeInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
  position: relative;
}
.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}
</style>